import Card from '../UI/Card';
import MealItem from './MealItem/MealItem';
import classes from './AvailableMeals.module.css';

const DUMMY_MEALS = [
  {
    id: 'm1',
    name: 'Tỏi Lý Sơn',
    description: 'Thơm Ngon, Chính Hiệu',
    price: 100,
  },
  {
    id: 'm2',
    name: 'Chả Cá Lý Sơn',
    description: 'Thơm Ngon, Nguyên Chất',
    price: 180,
  },
  {
    id: 'm3',
    name: 'Tỏi Đen Lý Sơn',
    description: 'Nguyên Chất, Thơm Ngon',
    price: 1000,
  },
  {
    id: 'm4',
    name: 'Tỏi Cô Đơn',
    description: 'Chính Hiệu, Đặc Biệt',
    price: 1000,
  },
];

const AvailableMeals = () => {
  const mealsList = DUMMY_MEALS.map((meal) => (
    <MealItem
      key={meal.id}
      id={meal.id}
      name={meal.name}
      description={meal.description}
      price={meal.price}
    />
  ));

  return (
    <section className={classes.meals}>
      <Card>
        <ul>{mealsList}</ul>
      </Card>
    </section>
  );
};

export default AvailableMeals;
